import { fetcher } from '@commenda/utils';

import { ICreateFileShareRequest, IExternalShare } from './types';

export const createFileShare = async (
  body: ICreateFileShareRequest
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher('file-shares', { method: 'POST', body });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to create share link.');
  }
  return await res.json();
};
